import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'percentageDecreaseOrIncrease'
})
export class PercentageDecreaseAndIncreasePipe implements PipeTransform {
  transform(previousValue: number, currentValue: number): number | string {
    if (previousValue === 0 || currentValue === 0) {
      return 1;
    }

    const value = currentValue >= previousValue
      ? Math.abs(Number((currentValue - previousValue) / previousValue))
      : Math.abs(Number((currentValue - previousValue) / currentValue));

    return value.toFixed(4) || 0;
  }
}
